import { render, staticRenderFns } from "./PatientProfileEditor.vue?vue&type=template&id=6c054027&scoped=true&"
import script from "./PatientProfileEditor.vue?vue&type=script&lang=ts&"
export * from "./PatientProfileEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PatientProfileEditor.vue?vue&type=style&index=0&id=6c054027&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c054027",
  null
  
)

export default component.exports